import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from 'src/contexts/AuthContext';

const AuthLandingRedirect: React.FC = () => {
  const { user, loading, getFavoritePath } = useAuth();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={getFavoritePath()} replace />;
};

export default AuthLandingRedirect;
